import React, { useEffect, useState } from 'react';
import { FiDatabase, FiCpu, FiShield } from 'react-icons/fi';
import * as api from '../api/api';
import { getSessionPhase } from '../utils/sessionPhase';

const etTime = () => new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  hour: '2-digit', minute: '2-digit',
  hour12: false
}).format(new Date());

const TerminalBar = () => {
  const [clock, setClock] = useState(etTime());
  const [health, setHealth] = useState(null);
  const [intel, setIntel] = useState(null);
  const [bot, setBot] = useState(null);

  useEffect(() => {
    const tick = setInterval(() => setClock(etTime()), 1000);
    let alive = true;
    const refresh = async () => {
      const results = await Promise.allSettled([
        api.getLocalHealth(),
        api.getIntelligenceStatus(),
        api.getBotStatus(),
      ]);
      if (!alive) return;
      if (results[0].status === 'fulfilled') setHealth(results[0].value.data);
      if (results[1].status === 'fulfilled') setIntel(results[1].value.data);
      if (results[2].status === 'fulfilled') setBot(results[2].value.data);
    };
    refresh();
    const statusTimer = setInterval(refresh, 12000);
    return () => {
      alive = false;
      clearInterval(tick);
      clearInterval(statusTimer);
    };
  }, []);

  const phase = getSessionPhase(intel?.calendar?.today_is_trading_session !== false);
  const provider = intel?.provider || 'NO DATA';
  const runtimeOk = Boolean(health?.runtime_alive);

  return (
    <div className="terminal-bar premium-topbar">
      <div className="premium-topbar-left">
        <span className="market-label">US EQUITIES</span>
        <span className={'session-pill ' + (phase.key === 'LIVE' ? 'is-live' : '')}>{phase.label}</span>
        <span className="market-clock">{clock} ET</span>
      </div>

      <div className="premium-topbar-center">
        <span className={'top-status ' + (intel?.configured ? 'good' : 'muted')}>
          <FiDatabase/><em>Data</em><strong>{provider}</strong>
        </span>
        <span className={'top-status ' + (runtimeOk ? 'good' : 'muted')}>
          <FiCpu/><em>Runtime</em><strong>{runtimeOk ? 'Ready' : 'Idle'}</strong>
        </span>
        <span className={'top-status ' + (health?.broker_connected ? 'good' : 'muted')}>
          <FiShield/><em>Broker</em><strong>{health?.broker_connected ? 'IBKR Paper' : 'Optional'}</strong>
        </span>
      </div>

      <div className="premium-topbar-right">
        <span className={'execution-chip ' + (bot?.is_running ? 'running' : '')}>
          <i /> {bot?.is_running ? 'PAPER ENGINE ON' : 'PAPER ENGINE OFF'}
        </span>
      </div>
    </div>
  );
};

export default TerminalBar;
